import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export interface PostalCodeResult {
  cp: string;
  country: string;
  state_code: string;
  state_name: string;
  city: string | null;
  municipality: string;
  colonias: string[];
}

class GeoService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  /**
   * GET /api/v1/geo/postal-code/{cp}?country={country}
   *
   * Returns state, city, municipality and colonia list for a postal code.
   * Supports MX (SEPOMEX) and US (GeoNames). Returns null on 404 or any
   * error — callers degrade gracefully to free-text entry rather than
   * blocking onboarding.
   */
  async lookupPostalCode(cp: string, country = 'MX'): Promise<PostalCodeResult | null> {
    try {
      const res = await this.api.get<PostalCodeResult>(
        `/api/v1/geo/postal-code/${encodeURIComponent(cp)}`,
        { params: { country } },
      );
      return res.data;
    } catch {
      return null;
    }
  }
}

export default new GeoService();
